
import VueAxios from "vue-axios";
import axios from "axios";
//Vue.use(VueAxios, axios);
//Vue.use(Vuex)
//const this.$store.state.baseapi = "http://127.0.0.1:8000/api/";
export default {
    data() {
      return {
       
      }
    },
  
    created() {
     
    },
  
    methods: {
     
     GET_POA_DESARROLLO_SOCIAL: async function(data) {




      
      var result =  await axios
        ({
          method: 'GET',
          url: this.$store.state.baseapi+"sistema_municipios/"+data.idmunicipio+"/poa_gobiernos/"+data.idgobierno+"/poa_desarrollo_sociales/",
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },








    CREAR_POA_DESARROLLO_SOCIAL: async function(data) {



      
      var result =  await axios
        ({
          method: 'POST',
          url: this.$store.state.baseapi+"poa_desarrollo_sociales/" ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
          data:{
          //QUITAR COMILLAS SOLO EN DATA 
          nombre:data.nombre,
          clave:data.clave,
          descripcion:data.descripcion,
          idmunicipio:data.idmunicipio,
          idgobierno:data.idgobierno,  
          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },





    EDITAR_POA_DESARROLLO_SOCIAL: async function(data) {




      
      var result =  await axios
        ({
          method: 'PUT',
          url: this.$store.state.baseapi+"poa_desarrollo_economicos/"+data.id ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
          data:{
            'nombre':data.nombre,
            'clave':data.clave,
            'descripcion':data.descripcion,
           // idmunicipio:data.idmunicipio,
            
          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },

    ELIMINAR_POA_DESARROLLO_SOCIAL: async function(data) {




      
      var result =  await axios
        ({
          method: 'delete',
          url: this.$store.state.baseapi+"poa_desarrollo_economicos/"+data.id ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },
    },
  }